import * as yup from 'yup'

import {isValidE164PhoneNumber, normalizeStoredPhoneNumber} from '@/utils/formatting/phone-number'

// Apart from ./utils, so libphonenumber only loads with the schemas that have a phone number

const isEmptyOrValid = (value?: string | null) => !value || isValidE164PhoneNumber(value)

// A number stored before E.164 was required is normalised first, so an old record still validates
// (e.g. an unpaid order opened on its payment step) and a validated body stores it as E.164
export const phone = (required = false) => {
  const base = yup
    .string()
    .ensure()
    .transform(normalizeStoredPhoneNumber)
    .test('phone', 'error-invalid-phone', isEmptyOrValid)

  if (required) {
    return base.required('error-missing-phone')
  }
  return base
}

export const phoneOptional = phone()

// for partial updates, where ensure() would turn a number that wasn't sent into '' and clear it
export const phoneUpdate = yup
  .string()
  .nullable()
  .optional()
  .transform((value) => (value == null ? value : normalizeStoredPhoneNumber(value)))
  .test('phone', 'error-invalid-phone', isEmptyOrValid)
